export default __webpack_public_path__ + "static/media/linkedin_orange.b187a273.svg";